<template>
    <div class="sheet-wrap">
        <div class="sheet-box">
            <v-layout class="logo-wrap" justify-center>
                <img
                    v-if="$gameData.images.logo"
                    :src="$gameData.images.logo.url" width="315" />
                <img src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/btn_show_result.png" class="btn-show-result" @click="(showResult = true) && $playAudio(1)" />
            </v-layout>

            <v-layout
                v-if="step === 1"
                column
                align-center
                class="sheet1-wrap"
            >
                <div class="sheet1">
                    <div class="list-draggable"
                         ref="valueList"
                    >
                        <div v-for="(n, index) in valueList" :key="index" class="item list-item"
                             :data-no="n"
                        >
                            <img :src="`https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/sheet_value${n}.png`"
                            />
                        </div>
                    </div>

                    <div class="value-draggable values1"
                         ref="value1"
                         data-wrap-no="1"
                    >
                        <div v-for="(n, index) in values[1]" :key="index" class="item">
                            <img :src="`https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/sheet_value${n}.png`" />
                            <img class="btn-delete"
                                 src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/btn_delete_value.png"
                                 @click="removeValue(1, n, index)"
                            />
                        </div>
                    </div>

                    <div class="value-draggable values2"
                         ref="value2"
                         data-wrap-no="2"
                    >
                        <div v-for="(n, index) in values[2]" :key="index" class="item">
                            <img :src="`https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/sheet_value${n}.png`" />
                            <img class="btn-delete"
                                 src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/btn_delete_value.png"
                                 @click="removeValue(2, n, index)"
                            />
                        </div>
                    </div>

                    <div class="value-draggable values3"
                         ref="value3"
                         data-wrap-no="3"
                    >
                        <div v-for="(n, index) in values[3]" :key="index" class="item">
                            <img :src="`https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/sheet_value${n}.png`" />
                            <img class="btn-delete"
                                 src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/btn_delete_value.png"
                                 @click="removeValue(3, n, index)"
                            />
                        </div>
                    </div>

                </div>

                <div class="buttons">
                    <img class="btn-next"
                         v-if="canGoNext"
                         src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/btn_sheet_next.png"
                         @click="next"
                    />
                    <img class="btn-next"
                         v-else
                         src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/btn_sheet_next_disabled.png" />
                </div>

            </v-layout>

            <v-layout
                v-if="[2,3,4].indexOf(step) > -1"
                column
                align-center
                :class="`sheet${step}-wrap`"
            >
                <div :class="`sheet${step}`">
                    <div class="values list-draggable"
                         ref="values"
                    >
                        <div v-for="(n, index) in values[step-1]" :key="index" class="item list-item"
                             :data-no="n"
                        >
                            <img :src="`https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/sheet_value_l${n}.png`"
                            />
                        </div>
                    </div>

                    <div class="sorted-wrap">
                        <div v-for="(n, index) in sorted[step-1]" :key="index" class="sorted"
                             ref="sorted"
                        >
                            <img v-if="typeof n !== 'undefined'"
                                 :src="`https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/sheet_value_l${n}.png`" />
                            <img class="btn-delete"
                                 v-if="typeof n !== 'undefined'"
                                 src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/btn_delete_value_l.png"
                                 @click="removeValue(step-1, n, index)"
                            />
                        </div>
                    </div>
                </div>

                <div class="buttons">
                    <img class="btn-prev"
                         src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/btn_sheet_prev.png"
                         @click="prev"
                    />
                    <img class="btn-next"
                         v-if="canGoNext"
                         src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/btn_sheet_next.png"
                         @click="next"
                    />
                    <img class="btn-next"
                         v-else
                         src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/btn_sheet_next_disabled.png" />
                </div>
            </v-layout>

            <v-layout
                class="graph-wrap"
                justify-center
                :class="`step${step}`"
                v-if="[5,6].indexOf(step) > -1"
            >
                <div class="graph">
                    <div class="values">
                        <img
                            v-for="value in sortedValues"
                            :key="value.no"
                            :src="`https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/sheet_value${value.no}.png`"
                        />
                    </div>

                    <div class="canvas-wrap">
                        <canvas id="canvas" class="canvas" width="570" height="1020"></canvas>
                    </div>
                </div>

                <div class="change-values-wrap"
                     v-if="step === 6"
                >
                    <div class="change-values">
                        <select ref="keyword" @change="adjustAmount" @focus="$playAudio(1)" :disabled="!adjustRemain">
                            <option value="">가치</option>
                            <option v-for="(item, index) in availables" :value="item.no">{{ item.keyword }}</option>
                        </select>
                        <select ref="amount" @change="adjustAmount" @focus="$playAudio(1)" :disabled="!adjustRemain">
                            <option value="">행동 수준</option>
                            <option v-for="(i, index) in adjustRemain" :value="i">{{ i }}</option>
                        </select>
                        <div class="added">
                            <div class="added-item" v-for="(item, index) in added">
                                <span class="added-keyword">{{ item.keyword }}</span>
                                <span class="added-amount">
                                            +{{ item.amount }}
                                            <img src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/btn_remove.png"
                                                 v-if="!adjustCompleted"
                                                 @click="removeAdded(index)"
                                                 style="display:inline-block; margin-left:15px; width: 19px; cursor: pointer"
                                            />
                                        </span>
                            </div>
                        </div>
                        <div class="btn-complete">
                            <img v-if="!adjustCompleted && !adjustRemain"
                                 src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/btn_complete_active.png"
                                 @click="completeAdjust"
                            />
                            <img v-else
                                 style="cursor: default"
                                 src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/btn_complete.png"
                            />

                        </div>
                    </div>
                </div>

                <div class="buttons"
                     v-if="step === 5"
                >
                    <img class="btn-next"
                         v-if="canGoNext"
                         src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/btn_sheet_next.png"
                         @click="next"
                    />
                    <img class="btn-next"
                         style="cursor: default"
                         v-else
                         src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/btn_sheet_next_disabled.png" />
                </div>
            </v-layout>

            <v-layout class="qna-wrap"
                      v-if="step === 7"
                      column
            >
                <div class="label">
                    <img class="label-light" src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/label_light.png" />
                    '{{$cookie.get('name')}}' 님의 인생 <span class="highlight">Q&A</span>

                    <img class="label-hint" src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/hint_sheet7.png" />
                </div>
                <div class="qna-items">
                    <div v-for="i in 6">
                        <img :src="`https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/qna_label_new${i}.png`" />
                        <div class="textfield">
                            <textarea v-model="fields[i]" :class="completed ? 'completed' : ''" :readonly="completed" v-if="!completed" />
                            <div class="answer" v-text="fields[i]" v-else></div>
                        </div>
                    </div>
                </div>
                <div class="button"
                     v-if="fields.filter(e => !!e).length === 6"
                >
                    <img src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/btn_submit.png" @click="submit()" />
                </div>
            </v-layout>

            <div class="pdf-graph-wrap">
                <div class="pdf-graph"
                     ref="graph"
                >
                    <div class="values">
                        <div class="value"
                             v-for="value in sortedValues"
                             :key="value.no"
                        >{{ keywords[value.no] }}</div>
                    </div>

                    <canvas id="result" class="result-graph"
                            width="1280"
                            height="1590"
                    ></canvas>
                </div>
            </div>

        </div>
        <v-layout class="result-popup-wrap" align-center justify-center v-if="showResult">
            <div class="result-popup">
                <Result :popup="true" class="result-wrap" style="width: 1200px;" />
                <img src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/background_result.png" class="border-result" />
                <img src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/btn_result_close.png" class="btn-result-close" @click="closeResult" />
            </div>
        </v-layout>

        <transition name="fade">
            <v-layout class="popup-wrap"
                      v-if="showPopup"
                      align-center justify-center
            >
                <div class="popup">
                    <v-layout fill-height column>
                        <v-layout class="message" fill-height justify-center align-center v-html="brMessage"></v-layout>
                        <v-layout class="popup-button" justify-center align-center>
                            <img src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/btn_popup_cancel.png"
                                 class="mr-2"
                                 v-if="okCb"
                                 @click="onClickPopupCancel" />

                            <img src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/btn_popup_ok.png" @click="onClickPopupOk" />
                        </v-layout>
                    </v-layout>
                </div>
            </v-layout>
        </transition>
        <div class="font">1</div>
    </div>
</template>

<script>
    import draggable from 'vuedraggable'
    import dragula from 'dragula'
    import Result from './Result'
    import html2canvas from "html2canvas"

    export default {
        components: {
            draggable,
            Result
        },
        data() {
            return {
                drake: null,
                showResult: false,
                showPopup: false,
                popupMessage: '',
                okCb: null,
                cancelCb: null,

                keywords: {
                    1: '자존',
                    2: '자유',
                    3: '건강',
                    4: '신념',
                    5: '부',
                    6: '재미',
                    7: '안정',
                    8: '사랑',
                    9: '책임',
                    10: '헌신',
                    11: '신뢰',
                    12: '협력',
                    13: '인정',
                    14: '조화',
                    15: '공정',
                    16: '가족',
                    17: '학습',
                    18: '도전',
                    19: '창의',
                    20: '성취',
                    21: '변화',
                    22: '완벽',
                    23: '성실',
                    24: '열정',
                },
                adjustRemain: 10,
                adjustCompleted: false,
                added: [],
                values: {
                    1: [],
                    2: [],
                    3: [],
                    // 1: [1,2,3,4,5,6,7,8],
                    // 2: [9,10,11,12,13,14,15,16],
                    // 3: [17,18,19,20,21,22,23,24]
                },
                sorted: {
                    1: new Array(8),
                    2: new Array(8),
                    3: new Array(8),
                    // 1: [1,2,3,4,5,6,7,8],
                    // 2: [9,10,11,12,13,14,15,16],
                    // 3: [17,18,19,20,21,22,23,24]
                },
                backup: null,
                step: 1,
                draggingIndex: -1,
                targetIndex: -1,

                boxWidth: 30,
                boxHeight: 30,
                pointWidth: 10,
                pointHeight: 10,

                points: {},
                hintPoint: {},
                sortedValues: [],

                fields: new Array(6),

                completed: false,
            }
        },

        watch: {
        },

        computed: {
            valueSum() {
                let sum = 0

                this.sortedValues.forEach(item => {
                    if (item && item.value) sum += +item.value
                })

                return sum
            },
            valueList() {
                return _.range(1, 25)
            },
            brMessage() {
                return (this.popupMessage || '').replace(/\n/g, '<br />')
            },
            canGoNext() {
                if (this.step === 1) {
                    let cnt = 0
                    Object.values(this.values).forEach(v => cnt += v.length)

                    if (cnt === 24) return true
                } else if (this.step === 5) {
                    let cnt = 0
                    Object.values(this.sortedValues).forEach(v => cnt += v.value ? 1 : 0)
                    if (cnt === 24) return true
                } else if (this.step === 6) {
                    return this.adjustCompleted
                } else {
                    let cnt = 0
                    Object.values(this.sorted[this.step - 1]).forEach(v => cnt += v ? 1 : 0)

                    if (cnt === 8) return true

                }

                return false
            },
            availables() {
                const list = []
                const added = this.added.map(item => { return item.no })

                this.sortedValues.forEach(item => {
                    if (!item || !item.no) return
                    if (added.indexOf(item.no) === -1) {
                        list.push({
                            keyword: this.keywords[item.no],
                            no: item.no
                        })
                    }
                })

                return list

            },
        },

        created() {
        },

        beforeMount() {
            const id = this.$cookie.get('id')
            const localUserData = localStorage.getItem(`userData${id}`)
            if (localUserData) {
                const userData = JSON.parse(localUserData)
                Object.keys(userData).forEach(key => {
                    this.$set(this.$userData, key, userData[key])
                })
            }

            this.$eventBus.$off('SHOW_POPUP', this.openPopup)
        },

        mounted() {
            this.$stopAll()
            this.$eventBus.$on('SHOW_POPUP', this.openPopup)

            this.setDraggable()

            if (this.step >= 5) {
                setTimeout(_ => {
                    this.drawGraph()
                    this.setCanvasListener()
                }, 500)
            }
        },

        methods: {
            setDraggable() {
                if (this.drake) {
                    this.drake.destroy()
                }

                if (this.step === 1) {
                    const {valueList, value1, value2, value3} = this.$refs

                    this.drake = dragula([
                        valueList, value1, value2, value3
                    ], {
                        copy: true,
                        invalid: function (el, handle) {
                            if ($(el).hasClass('selected')) {
                                return true
                            }

                            return false
                        }
                    })
                        .on('over', (el, container, source) => {
                            const wrapNo = $(container).data('wrap-no')
                            if (wrapNo) {
                                if (this.values[wrapNo].length === 8) {
                                    $(container).css('pointer-events', 'none')
                                }
                            }
                        })
                        .on('out', (el, container, source) => {
                            $(container).css('pointer-events', '')
                        })
                        .on('drop', (el, container) => {
                            if (!container) {
                                this.drake.cancel(true)
                                return
                            }
                            const wrapNo = $(container).data('wrap-no')
                            if (this.values[wrapNo].length === 8) {
                                this.drake.cancel(true)
                                return
                            }
                            this.$playAudio(1)

                            const no = $(el).data('no')

                            const index = this.valueList.indexOf(no)
                            $('.list-draggable .item').eq(index).addClass('selected')

                            this.values[wrapNo].push(no)
                            $(el).remove()
                        })
                        .on('shadow', function (el, container, source) {
                            // check if the shadow copy is not already the last child of the container
                            if (el !== container.children[container.children.length - 1]) {
                                container.appendChild(el);
                            }
                        })
                } else if ([2,3,4].indexOf(this.step) > -1) {

                    this.drake = dragula([
                        this.$refs.values, ...this.$refs.sorted
                    ], {
                        copy: true,
                        accepts: function (el, target) {
                            if ($(target).hasClass('completed')) return false

                            return true
                        },
                        invalid: function (el, handle) {
                            if ($(el).hasClass('selected')) {
                                return true
                            }

                            return false
                        }
                    })
                        .on('over', (el, container, source) => {
                            if ($(container).hasClass('completed')) {
                                this.drake.cancel(true)
                                return false
                            }
                        })
                        .on('cancel', el => {
                            setTimeout(_ => {
                                $(el).remove()
                            })
                        })
                        .on('drop', (el, container) => {
                            if (!container) {
                                this.drake.cancel(true)
                                return
                            }

                            this.$playAudio(1)

                            $(container).addClass('completed')
                            const no = $(el).data('no')

                            const index = this.values[this.step - 1].indexOf(no)
                            $('.list-draggable .item').eq(index).addClass('selected')

                            const targetIndex = $('.sorted').index(container)

                            this.sorted[this.step - 1].splice(targetIndex, 1, no)
                            $(el).remove()
                        })
                    // .on('shadow', function (el, container, source) {
                    //     // check if the shadow copy is not already the last child of the container
                    //     if (el !== container.children[container.children.length - 1]) {
                    //         // otherwise: make it so
                    //         container.appendChild(el);
                    //     }
                    // })
                }
            },
            setSortedValues() {

                const values = [...this.sorted[1], ...this.sorted[2], ...this.sorted[3]]
                values.forEach(v => {
                    this.sortedValues.push({
                        no: v,
                    })
                })
            },
            setCanvasListener() {
                const canvas = document.getElementById('canvas')
                if (!canvas) {
                    setTimeout(_ => {
                        this.setCanvasListener()
                    })
                    return
                }
                $(canvas).click(e => {
                    const x = e.offsetX
                    const y = e.offsetY

                    let target, valueSum
                    Object.keys(this.points).forEach(id => {
                        if (this.step !== 5) return

                        Object.keys(this.points[id]).forEach(value => {
                            const point = this.points[id][value]


                            if (x > point.x && x < point.x + this.boxWidth) {
                                if (y > point.y && y < point.y + this.boxHeight) {
                                    this.$playAudio(1)
                                    const index = id - 1

                                    let valueSum = this.valueSum
                                    if (this.sortedValues[index].value) {
                                        valueSum -= this.sortedValues[index].value
                                    }

                                    if (valueSum + +value > 200) {
                                        this.openPopup('행동 수준은 200점 이상 체크할 수 없습니다.')
                                        return
                                    }
                                    this.$set(this.sortedValues[index], 'value', value)

                                    this.hintPoint = null

                                }
                            }
                        })
                    })

                    this.drawGraph()
                })

                $(canvas).on('mousemove', e => {
                    if (this.step !== 5) return

                    const x = e.offsetX
                    const y = e.offsetY

                    let isOnBox = false

                    Object.keys(this.points).forEach(id => {

                        Object.keys(this.points[id]).forEach(value => {
                            const point = this.points[id][value]

                            if (x > point.x && x < point.x + this.boxWidth) {
                                if (y > point.y && y < point.y + this.boxHeight) {

                                    if (this.sortedValues[id - 1].value !== value) {
                                        this.hintPoint = {
                                            x: value,
                                            y: id,
                                        }

                                        isOnBox = true
                                    }
                                }
                            }
                        })
                    })

                    if (!isOnBox) {
                        this.hintPoint = null
                    }

                    this.drawGraph()
                })

                $(canvas).on('mouseout', e => {
                    this.hintPoint = null
                    this.drawGraph()
                })
            },
            drawGraph() {

                if (this.sortedValues.length === 0) {
                    this.setSortedValues()
                }

                const canvas = document.getElementById('canvas')
                if (!canvas) {
                    setTimeout(_ => {
                        this.drawGraph()
                    })
                    return
                }
                const ctx = canvas.getContext('2d')

                const arrow = (p1, p2, size) => {
                    const angle = Math.atan2((p2.y - p1.y) , (p2.x - p1.x));
                    let hyp = Math.sqrt((p2.x - p1.x) * (p2.x - p1.x) + (p2.y - p1.y) * (p2.y - p1.y));

                    ctx.save();
                    ctx.translate(p1.x + this.pointWidth / 2, p1.y);
                    ctx.rotate(angle);

                    // line
                    ctx.beginPath();
                    ctx.moveTo(0, 0);
                    ctx.lineTo(hyp - size, 0);
                    ctx.strokeStyle = '#ffffff'
                    ctx.setLineDash([5,5])
                    ctx.stroke();


                    hyp -= this.pointWidth / 2

                    ctx.beginPath();
                    ctx.setLineDash([])
                    ctx.lineTo(hyp - size, size);
                    ctx.lineTo(hyp, 0);
                    ctx.lineTo(hyp - size, -size);
                    ctx.fillStyle = '#ffffff'
                    ctx.fill();
                    ctx.restore()

                }

                const cellWidth = Math.floor(canvas.width / 9) - 1.5
                const cellHeight = Math.floor(canvas.height / 24)

                ctx.clearRect(0, 0, canvas.width, canvas.height)

                // 세로선
                for (let x=1;x<=9;x++) {
                    ctx.beginPath();
                    ctx.moveTo(cellWidth * x, 7)
                    ctx.lineTo(cellWidth * x, canvas.height - 15)
                    ctx.setLineDash([canvas.width/40, canvas.width/100])
                    ctx.lineWidth = 1
                    ctx.strokeStyle = 'rgba(255,255,255,0.1)'
                    ctx.stroke()
                }
                // 가로선
                for (let y=1;y<=24; y++) {
                    ctx.beginPath();
                    ctx.moveTo(5, cellHeight * y - 5)
                    ctx.lineTo(canvas.width - 16, cellHeight * y - 5)
                    ctx.setLineDash([canvas.width/40, canvas.width/100])
                    ctx.lineWidth = 1
                    ctx.strokeStyle = 'rgba(255,255,255,0.1)'
                    ctx.stroke()
                }

                // 마우스 클릭 박스배치
                this.points = {}
                for (let y=1; y<=24; y++) {
                    this.points[y] = {}
                    for (let x=1; x<=9; x++) {
                        const point = {
                            x: cellWidth * x - this.boxWidth / 2,
                            y: cellHeight * y - this.boxWidth / 2 - 5,
                        }
                        this.points[y][x] = point

                        ctx.beginPath();
                        ctx.setLineDash([])
                        ctx.rect(point.x, point.y, this.boxWidth, this.boxHeight);
                        ctx.fillStyle = 'rgba(255,255,255,0)'
                        ctx.fill()
                    }
                }

                ctx.font = '19px "5x5Pixel"'


                if (this.hintPoint) {
                    const hintWidth = 21
                    const hintHeight = 21

                    const point = {
                        x: cellWidth * this.hintPoint.x - hintWidth / 2,
                        y: cellHeight * this.hintPoint.y - hintHeight / 2 - 5,
                    }

                    ctx.beginPath();
                    ctx.setLineDash([])
                    ctx.rect(point.x, point.y, hintWidth, hintHeight);
                    ctx.fillStyle = '#eda637'
                    ctx.fill()

                    ctx.textBaseline = 'middle'
                    ctx.textAlign = 'center'
                    ctx.fillStyle = '#19162a'
                    ctx.fillText(""+this.hintPoint.x, point.x + hintWidth / 2 + 1, point.y + hintHeight / 2 - 4)
                }

                let lastPoint

                this.sortedValues.forEach((item, index) => {

                    if (!item || !item.value) return

                    // 노란점 찍기
                    const point = this.points[index + 1][item.value]
                    const rectX = point.x + (this.boxWidth / 2) - (this.pointWidth / 2)
                    const rectY = point.y + (this.boxHeight / 2) - (this.pointHeight / 2)
                    ctx.beginPath();
                    ctx.setLineDash([])
                    ctx.rect(rectX , rectY, this.pointWidth, this.pointHeight);
                    ctx.fillStyle = '#eda637'
                    ctx.fill()

                    // 노란선 그리기
                    if (lastPoint) {
                        ctx.beginPath();
                        ctx.moveTo(lastPoint.x + (this.boxWidth / 2), lastPoint.y + (this.boxHeight / 2))
                        ctx.lineTo(point.x + (this.boxWidth / 2), point.y + (this.boxHeight / 2))
                        ctx.setLineDash([])
                        ctx.lineWidth = 1
                        ctx.strokeStyle = '#eda637'
                        ctx.stroke()
                    }

                    lastPoint = point

                    if (item.added) {
                        const toPoint = this.points[index + 1][parseInt(item.added) + parseInt(item.value)]
                        const p1 = { x: point.x + (this.boxWidth / 2), y: point.y + (this.boxHeight / 2)}
                        const p2 = { x: toPoint.x + (this.boxWidth / 2), y: toPoint.y + (this.boxHeight / 2)}

                        arrow(p1, p2, 5)
                    }
                })
            },
            adjustAmount(e) {
                this.$playAudio(1)
                const no = parseInt(this.$refs.keyword.value)
                const amount = this.$refs.amount.value

                if (!no || !amount) return

                let sorted, index
                this.sortedValues.forEach((item, idx) => {
                    if (item.no === no) {
                        sorted = item
                        index = idx
                    }
                })

                if (+sorted.value + +amount > 9) {
                    this.openPopup('행동 수준의 합은\n9를 넘을 수 없습니다.')
                    return
                }
                const keyword = this.keywords[sorted.no]

                this.$set(this.sortedValues[index], 'added', amount)

                this.added.push({
                    no: sorted.no,
                    keyword: keyword,
                    amount: amount,
                })

                this.adjustRemain -= amount

                this.$refs.keyword.value = ''
                this.$refs.amount.value = ''

                this.drawGraph()
            },

            removeAdded(index) {
                this.$playAudio(1)
                const removed = this.added.splice(index, 1)
                this.adjustRemain += parseInt(removed[0].amount)

                this.sortedValues.forEach((item, idx) => {
                    if (item.no === removed[0].no) {
                        this.$set(this.sortedValues[idx], 'added', null)
                    }
                })
                this.drawGraph()
            },

            completeAdjust() {
                this.$playAudio(1)
                this.adjustCompleted = true
                this.drawGraphResult()
                this.next()
            },

            removeValue(grade, n) {
                this.$playAudio(1)

                if (this.step === 1) {
                    this.values[grade] = this.values[grade].filter(e => e !== n)

                    const index = this.valueList.indexOf(n)
                    $('.list-draggable .item').eq(index).removeClass('selected')
                } else {
                    const targetIndex = this.sorted[grade].indexOf(n)
                    this.$set(this.sorted[grade], targetIndex, undefined)
                    $('.sorted').eq(targetIndex).removeClass('completed')

                    const index = this.values[grade].indexOf(n)
                    $('.values .item').eq(index).removeClass('selected')
                }
            },

            prev() {
                this.$playAudio(1)

                if (this.backup) {
                    this.sorted[this.step - 1] = this.backup
                }

                this.step--
                setTimeout(_ => {
                    this.setDraggable()
                })

                if (this.step === 1) {
                    setTimeout(_ => {

                        $('.list-draggable .item').addClass('selected')
                        $('.value1').css('pointer-events', 'none')
                        $('.value2').css('pointer-events', 'none')
                        $('.value3').css('pointer-events', 'none')

                    })
                    this.backup = _.cloneDeep(this.values)

                } else {
                    $('.values .item').addClass('selected')
                    $('.sorted').addClass('completed')
                    this.backup = _.cloneDeep(this.sorted[this.step - 1])
                }
            },

            next() {
                this.$playAudio(1)
                if (this.step < 4) {
                    if (this.backup) {
                        const backup = _.cloneDeep(this.backup)
                        this.backup = null
                        if (this.step === 1) {

                            let changed = false
                            Object.keys(backup).forEach(k => {
                                backup[k].forEach(v => {
                                    if (this.values[k].indexOf(v) === -1) {
                                        changed = true
                                    }
                                })
                            })

                            if (changed) {

                                this.openPopup('수정할 경우,\n다음에 나오는 모든 페이지도\n새로 작성해야 합니다.\n정말 수정하시겠습니까?',
                                    _ => {

                                        this.$set(this, 'sorted', {
                                            1: new Array(8),
                                            2: new Array(8),
                                            3: new Array(8),
                                        })

                                        this.step++
                                        this.okCb = null
                                        this.cancelCb = null
                                        this.showPopup = false

                                        this.resetNextStep()
                                    },
                                    () => {
                                        this.okCb = null
                                        this.cancelCb = null
                                        this.showPopup = false
                                        setTimeout(() => {
                                            this.openPopup('이전에 작성한 내용으로 돌아갑니다.')

                                            this.$set(this, 'values', _.cloneDeep(backup))
                                            this.backup = backup
                                        })

                                    }
                                )

                                return
                            }
                        } else {

                            let changed = false
                            this.sorted[this.step - 1].forEach((e, index) => {
                                if (backup[index] !== e) {
                                    changed = true
                                }
                            })

                            if (changed) {
                                this.openPopup('수정하시겠습니까?', _ => {

                                        this.step++
                                        this.okCb = null
                                        this.showPopup = false


                                        this.resetNextStep()
                                    },
                                    () => {
                                        this.okCb = null
                                        this.cancelCb = null
                                        this.showPopup = false
                                        setTimeout(() => {
                                            this.openPopup('이전에 작성한 내용으로 돌아갑니다.')

                                            this.$set(this.sorted, this.step - 1, _.cloneDeep(backup))
                                            this.backup = backup
                                        })
                                    }
                                )

                                return
                            }

                        }
                    }

                    this.step++
                    this.resetNextStep()

                } else {

                    if (this.step === 4) {

                        this.openPopup('다음 단계로 넘어가면\n더 이상 수정이 불가능합니다.\n\n다음 단계를 진행하시겠습니까?', _ => {

                            this.step++
                            this.okCb = null
                            this.showPopup = false

                            this.drawGraph()
                            this.setCanvasListener()
                        })
                        return
                    }

                    if (this.drake) {
                        this.drake.destroy()
                        this.drake = null
                    }
                    this.step++

                    if (this.step === 6) {
                        if (Object.keys(this.points).length === 0) {
                            this.drawGraph()
                            this.setCanvasListener()
                        }
                        $('.sheet-wrap').get(0).scrollTop = 0
                    }
                }
            },

            resetNextStep() {

                if (this.sorted[this.step - 1].filter(e => !!e).length !== 8) {
                    this.$set(this.sorted, this.step - 1, new Array(8))

                    $('.item.selected').removeClass('selected')
                    $('.sorted.completed').removeClass('completed')
                } else {
                    $('.values .item').addClass('selected')
                    $('.sorted').addClass('completed')
                }
                setTimeout(_ => {
                    this.setDraggable()
                })
            },

            closeResult() {
                this.$playAudio(1)
                this.showResult = false
            },

            openPopup(message, okCb, cancelCb) {
                this.showResult = false
                this.popupMessage = message
                this.showPopup = true
                this.okCb = okCb
                this.cancelCb = cancelCb
            },

            onClickPopupOk() {
                this.$playAudio(1);
                if (this.okCb) {
                    this.okCb()
                }
                this.showPopup = false;
                this.okCb = null;
                this.cancelCb = null
            },

            onClickPopupCancel() {
                this.$playAudio(1);
                if (this.cancelCb) {
                    this.cancelCb()
                }
                this.showPopup = false;
                this.okCb = null;
                this.cancelCb = null
            },

            submit() {
                this.$playAudio(1)

                let cnt = 0
                this.fields.forEach((field, index) => {
                    if (field) {
                        cnt++
                    }
                })

                if (cnt !== 6) {
                    this.openPopup('먼저 개인 시트 작성을 완료해주세요.')
                    return
                }


                this.openPopup('제출한 후에는 수정이 불가능합니다. 제출하시겠습니까?', _ => {
                    this.completed = true

                    this.send()
                    this.okCb = null
                    this.showPopup = false
                })
                // this.$store.commit('showDialog',{
                //     type: 'confirm',
                //     message: '제출한 후에는 수정이 불가능합니다. 제출하시겠습니까?.',
                //     okCb: ()=>{
                //         this.completed = true
                //
                //         this.send()
                //     },
                // });
            },

            send() {
                const params = {
                    no: [],
                    priority: [],
                    value: [],
                    added: [],
                }

                this.sortedValues.forEach((item, index) => {
                    params.no.push(index + 1)
                    params.priority.push(this.keywords[item.no])
                    params.value.push(item.value)
                    params.added.push(item.added)
                })

                this.fields.forEach((field, index) => {
                    params[`qna${index}`] = field
                })

                this.axios.post('/api/sheet', params)
                    .then(response => {
                        if (response.data.code === '0000') {
                            this.sendEmail()
                            // this.sendGenerate()
                        }
                    })

            },

            // sendGenerate() {
            //     this.axios.get('/api/graph')
            //         .then(response => {
            //             this.sendEmail()
            //         })
            // },

            sendEmail() {
                this.axios.post('/api/email/send')
                    .then(response => {
                        $('.button').hide()
                    })

            },

            drawGraphResult() {

                if (this.sortedValues.length === 0) {
                    this.setSortedValues()
                }
                const canvas = document.getElementById('result')
                const ctx = canvas.getContext('2d')

                const arrow = (p1, p2, size) => {
                    const angle = Math.atan2((p2.y - p1.y) , (p2.x - p1.x));
                    let hyp = Math.sqrt((p2.x - p1.x) * (p2.x - p1.x) + (p2.y - p1.y) * (p2.y - p1.y));

                    ctx.save();
                    ctx.translate(p1.x + this.pointWidth / 2, p1.y);
                    ctx.rotate(angle);

                    // line
                    ctx.beginPath();
                    ctx.lineWidth = 3
                    ctx.moveTo(7, 0);
                    ctx.lineTo(hyp - size, 0);
                    ctx.strokeStyle = '#ffffff'
                    ctx.setLineDash([10,10])
                    ctx.stroke();


                    hyp -= this.pointWidth / 2

                    ctx.beginPath();
                    ctx.setLineDash([])
                    ctx.lineTo(hyp - size, size);
                    ctx.lineTo(hyp, 0);
                    ctx.lineTo(hyp - size, -size);
                    ctx.fillStyle = '#ffffff'
                    ctx.fill();
                    ctx.restore()

                }

                const cellWidth = Math.floor(canvas.width / 9)
                const cellHeight = Math.floor(canvas.height / 24)

                const boxWidth = this.boxWidth * 2
                const boxHeight = this.boxHeight * 2

                const pointWidth = this.pointWidth * 2
                const pointHeight = this.pointHeight * 2

                ctx.clearRect(0, 0, canvas.width, canvas.height)

                // 세로선
                for (let x=1;x<=9;x++) {
                    ctx.beginPath();
                    ctx.moveTo(cellWidth * x - 10, 7)
                    ctx.lineTo(cellWidth * x - 10, canvas.height - 13)
                    // ctx.setLineDash([canvas.width/40, canvas.width/100])
                    ctx.lineWidth = 1
                    ctx.strokeStyle = 'rgba(255,255,255,0.1)'
                    ctx.stroke()
                }
                // 가로선
                for (let y=1;y<=24; y++) {
                    ctx.beginPath();
                    ctx.moveTo(5, cellHeight * y - 5)
                    ctx.lineTo(canvas.width - 13, cellHeight * y - 5)
                    // ctx.setLineDash([canvas.width/40, canvas.width/100])
                    ctx.lineWidth = 1
                    ctx.strokeStyle = 'rgba(255,255,255,0.1)'
                    ctx.stroke()
                }


                // 마우스 클릭 박스배치
                const points = {}
                for (let y=1; y<=24; y++) {
                    points[y] = {}
                    for (let x=1; x<=9; x++) {
                        const point = {
                            x: cellWidth * x - boxWidth / 2 - 10,
                            y: cellHeight * y - boxWidth / 2 - 5,
                        }
                        points[y][x] = point
                    }
                }

                let lastPoint

                this.sortedValues.forEach((item, index) => {

                    if (!item || !item.value) return

                    // 노란점 찍기
                    const point = points[index + 1][item.value]
                    const rectX = point.x + (boxWidth / 2) - (pointWidth / 2)
                    const rectY = point.y + (boxHeight / 2) - (pointHeight / 2)
                    ctx.beginPath();
                    ctx.setLineDash([])
                    ctx.rect(rectX , rectY, pointWidth, pointHeight);
                    ctx.fillStyle = '#eda637'
                    ctx.fill()

                    // 노란선 그리기
                    if (lastPoint) {
                        ctx.beginPath();
                        ctx.moveTo(lastPoint.x + (boxWidth / 2), lastPoint.y + (boxHeight / 2))
                        ctx.lineTo(point.x + (boxWidth / 2), point.y + (boxHeight / 2))
                        ctx.setLineDash([])
                        ctx.lineWidth = 3
                        ctx.strokeStyle = '#eda637'
                        ctx.stroke()
                    }

                    lastPoint = point

                    if (item.added) {
                        const toPoint = points[index + 1][parseInt(item.added) + parseInt(item.value)]
                        const p1 = { x: point.x + (boxWidth / 2), y: point.y + (boxHeight / 2)}
                        const p2 = { x: toPoint.x + (boxWidth / 2), y: toPoint.y + (boxHeight / 2)}

                        arrow(p1, p2, 12)
                    }
                })

                html2canvas(this.$refs.graph, {allowTaint: true, useCORS: true}).then(c => {
                    const dataURL = c.toDataURL('images/png')
                    const params = {
                        imgBase64: dataURL.replace(/^data:image\/(png|jpg);base64,/, "")
                    }

                    this.axios.post('/api/graph', params).then(response => {
                        console.log(response)
                    })
                    //
                    // const image = new Image();
                    // // image.src = "data:image/jpg;base64," + dataURL;
                    // image.src = dataURL
                    //
                    // const w = window.open("");
                    // w.document.write(image.outerHTML);
                })
            }


        }
    }
</script>

<style lang="scss" scoped>
    .sheet-wrap {
        height: 100vh;
        overflow-y: scroll;
        background-color: #19162a;
        padding-bottom: 120px;

        .label {
            position: relative;
            font-size: 25px;
            font-family: GmarketSans, sans-serif;
            font-weight: 600;
            color: #ffffff;
            padding-left: 67px;
            line-height: 1.28;

            margin-top: -30px;
            margin-bottom: 15px;

            .highlight {
                color: #eda637;
            }

            .label-light {
                position: absolute;
                top: -30px;
                left: -12px;
            }
            .label-hint {
                margin-left: 17px;

                &.blink {
                    -webkit-animation: blink-1 0.6s both;
                    animation: blink-1 0.6s both;
                }
            }
        }

        .sheet-box {
            width: 1278px;
            min-height: 100%;
            margin: 0 auto;
            position: relative;

            pointer-events: none;

            -webkit-touch-callout: none;
            -webkit-user-select: none;
            -khtml-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;

            .logo-wrap {
                padding-top: 67px;

                .btn-show-result {
                    position: absolute;
                    right: 77px;
                    top: 96px;
                    cursor: pointer;

                    pointer-events: auto;
                }
            }


            .sheet1-wrap {
                position: absolute;
                top: 241px;
                width: 100%;

                .sheet1 {
                    position: relative;
                    width: 1134px;
                    height: 678px;
                    background-image: url('https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/background_sheet_value1.png');
                    pointer-events: auto;

                    .list-draggable {
                        position: absolute;
                        left: 50px;
                        right: 40px;
                        top: 117px;
                        margin-top: -16px;

                        display: flex;
                        flex-wrap: wrap;


                        .item {
                            width: 75px;
                            height: 45px;
                            margin-right: 13px;
                            margin-top: 16px;

                            cursor: move;

                            &:nth-child(12n) {
                                margin-right: 0;
                            }
                        }

                    }

                    .value-draggable {
                        position: absolute;
                        top: 336px;
                        width: 360px;
                        height: 284px;

                        overflow: hidden;

                        padding: 56px 80px 0 99px;

                        display: flex;
                        flex-wrap: wrap;
                        align-content: flex-start;
                        pointer-events: auto;
                        cursor: default;

                        .item {
                            position: relative;
                            width: 75px;
                            height: 45px;
                            margin-bottom: 15px;
                            margin-right: 15px;
                            pointer-events: none;

                            img {
                                /*pointer-events: none;*/
                            }

                            .btn-delete {
                                position: absolute;
                                right: -12px;
                                top: -12px;
                                cursor: pointer;
                                pointer-events: auto;
                            }
                        }

                    }

                    .values1 {
                        left: 10px;
                    }

                    .values2 {
                        left: 390px;
                    }

                    .values3 {
                        left: 769px;
                    }

                }
            }

            .sheet2-wrap, .sheet3-wrap, .sheet4-wrap {
                position: absolute;
                top: 161px;
                width: 100%;

                .sheet2, .sheet3, .sheet4 {
                    position: relative;
                    width: 1280px;
                    height: 750px;

                    &.sheet2 {
                        background-image: url('https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/background_sheet_value2.png');
                    }
                    &.sheet3 {
                        background-image: url('https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/background_sheet_value3.png');
                    }
                    &.sheet4 {
                        background-image: url('https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/background_sheet_value4.png');
                    }

                    .values {
                        position: absolute;
                        left: 381px;
                        top: 230px;
                        width: 600px;

                        display: flex;
                        flex-wrap: wrap;

                        pointer-events: all;

                        .item {
                            margin-right: 19px;
                            margin-bottom: 15px;
                            cursor: move;
                        }
                    }

                    .sorted-wrap {
                        position: absolute;
                        left: 184px;
                        top: 491px;
                        width: 980px;

                        display: flex;
                        flex-wrap: wrap;
                        align-content: flex-start;

                        pointer-events: all;

                        .sorted {
                            position: relative;
                            width: 116px;
                            height: 70px;
                            margin: 15px 64px;

                            &:nth-child(4n-1) {
                                margin-right: 60px;
                            }

                            &.completed {
                                pointer-events: none;
                            }

                            .btn-delete {
                                position: absolute;
                                right: -18px;
                                top: -18px;
                                cursor: pointer;
                                pointer-events: auto;
                            }
                        }
                    }
                }
            }

            .graph-wrap {
                position: absolute;
                top: 217px;
                width: 100%;

                pointer-events: auto;

                .graph {
                    position: relative;
                    width: 831px;
                    height: 1279px;

                    background-image: url('https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/background_sheet4.png');

                    .values {
                        position: absolute;
                        left: 96px;
                        top: 190px;

                        display: flex;
                        flex-direction: column;

                        img {
                            width: 54px;
                            margin-bottom: 9.6px;
                        }
                    }

                    .canvas-wrap {
                        position: absolute;
                        left: 165px;
                        top: 170px;
                        width: 570px;
                        height: 1020px;

                        .canvas {
                            width: 100%;
                            height: 100%;
                        }
                    }
                }

                .change-values-wrap {
                    position: relative;
                    width: 319px;
                    height: 317px;

                    margin-left: 36px;
                    margin-top: 81px;

                    .change-values {
                        position: fixed;
                        width: 319px;
                        height: 317px;

                        padding: 30px 0 0 28px;
                        background-color: rgba(255,255,255,0.1);

                        font-family: GmarketSans, sans-serif;
                        font-size: 15px;

                        select {
                            -webkit-appearance: button;
                            background-color: #ffffff;
                            border-style: solid;
                            width: 127px;
                            height: 27px;
                            padding-left: 20px;

                            &+select {
                                margin-left: 3px;
                            }

                            option:first-child {
                                background-color: #efefef;
                            }
                        }



                        .added {
                            width: 262px;
                            height: 166px;
                            margin-left: 0;
                            margin-top: 16px;
                            font-weight: 400;
                            color: #ffffff;
                            text-align: left;
                            background-color: #19162a;

                            .added-item {
                                display: inline-block;
                                width: 130px;
                                margin-top: 8px;

                                .added-keyword {
                                    display: inline-block;
                                    width: 30px;
                                    margin-left: 25px;
                                }
                            }
                        }
                        .btn-complete {
                            position: absolute;
                            left: 85px;
                            bottom: 13px;

                            text-align: center;
                            img {
                                width: 148px;
                                cursor: pointer;
                            }
                        }
                    }
                }

                .buttons {
                    position: absolute;
                    top: 1258px;
                }
            }

            .qna-wrap {
                margin-top: 95px;
                margin-left: 72px;


                .qna-items {
                    width: 1146px;
                    height: 1619px;
                    margin-top: 21px;
                    background-image: url('https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/background_sheet2.png');
                    background-repeat: no-repeat;
                    background-size: cover;
                    padding-top: 72px;
                    padding-left: 80px;
                    position: relative;

                    .textfield {
                        width: 948px;
                        margin-left: 15px;
                        margin-top: 15px;
                        margin-bottom: 80px;
                        pointer-events: auto;

                        textarea {
                            width: 100%;
                            height: 128px;
                            border: 0;
                            background-color: #ffffff;
                            resize: none;
                            padding: 10px;
                        }

                        .answer {
                            color: #ffffff;
                            padding: 10px;
                            min-height: 128px;
                            margin-bottom: 0;
                            white-space: pre-wrap;
                            font-family: GmarketSans, sans-serif !important;
                        }
                    }
                }

                .button {
                    margin-top: 52px;
                    text-align: center;

                    cursor: pointer;

                    pointer-events: auto;
                }
            }

            .item.selected {
                opacity: 0.2;
                pointer-events: none;
            }

            .buttons {
                margin-top: 41px;
                text-align: center;
                pointer-events: all;

                padding-bottom: 50px;

                img {
                    cursor: pointer;

                    &+img {
                        margin-left: 25px;
                    }
                }
            }
        }

        .result-popup-wrap {
            position: fixed;
            top: 0; bottom: 0;
            left: 0; right: 0;
            background-color: rgba(0,0,0,0.63);

            .result-popup {
                position: absolute;
                width: 1178px;
                height: 691px;
                overflow: hidden;

                .border-result {
                    position: absolute;
                    left: 0;
                    top: 0;
                    pointer-events: none;
                }

                .btn-result-close {
                    position: absolute;
                    right: 0;
                    top: 0;
                    cursor: pointer;
                }
            }
        }

        .popup-wrap {
            position: absolute;
            left: 0; right: 0;
            top: 0; bottom: 0;
            background: rgba(0,0,0,0.63);

            .popup {
                width: 766px;
                height: 457px;
                background-image: url('https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/background_sheet_popup.png');
                background-repeat: no-repeat;
                background-size: cover;

                .message {
                    color: #f1ad2c;
                    font-size: 30px;
                    font-family: GmarketSans, sans-serif;
                    line-height: 1.5;
                    text-align: center;
                    padding: 20px 40px;
                    word-break: keep-all;
                    margin-top: 25px;
                }

                .popup-button {
                    padding-bottom: 64px;
                    img {
                        cursor: pointer;
                    }
                }
            }
        }
    }

    .pdf-graph-wrap {
        position: fixed;
        left: 0;
        top: 0;
        width: 1px;
        height: 1px;
        overflow: hidden;
        background-color: #19162a;
    }
    .pdf-graph {
        position: absolute;
        left: 0;
        top: 0;
        width: 1436px;
        height: 1645px;

        background-color: #19162a;
        background-image: url('/images/background_pdf_graph.png');

        .values {
            position: absolute;
            left: 60px;
            top: 96px;

            .value {
                width: 75px;
                font-family: GmarketSans, sans-serif;
                font-size: 30px;
                font-weight: bold;
                line-height: 1.2;
                color: #f6a002;

                &+.value {
                    margin-top: 29.9px;
                }
            }
        }

        .result-graph {
            position: absolute;
            left: 155px;
            top: 47px;
            width: 1280px;
            height: 1590px;
        }
    }

    .font {
        position: absolute;
        left: 0;
        top: 0;
        width: 1px;
        height: 1px;
        visibility: hidden;
        font-family: "5x5 Pixel", sans-serif;

    }

    /**
     * ----------------------------------------
     * animation blink-1
     * ----------------------------------------
     */
    @-webkit-keyframes blink-1 {
        0%,
        50%,
        100% {
            opacity: 1;
        }
        25%,
        75% {
            opacity: 0;
        }
    }
    @keyframes blink-1 {
        0%,
        50%,
        100% {
            opacity: 1;
        }
        25%,
        75% {
            opacity: 0;
        }
    }

</style>

<style>

    .hidden-ghost {
        opacity: 0.2 !important;
    }
    .gu-mirror { position: fixed !important; margin: 0 !important; z-index: 9999 !important; padding: 1em; } .gu-hide { display: none !important; } .gu-unselectable { -webkit-user-select: none !important; -moz-user-select: none !important; -ms-user-select: none !important; user-select: none !important; } .gu-transit { opacity: 0.5; -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=50)"; filter: alpha(opacity=50); } .gu-mirror { opacity: 0.5; -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=50)"; filter: alpha(opacity=50); }
</style>
